import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { ContractWorker } from "../_types/contract-worker";

@Injectable({
    providedIn: 'root',
})
export class ContractWorkersService extends Service<ContractWorker> {
  public override type = 'contractWorkers';  
  public override url = 'attendance/contractWorkers'; 
}
